import React from "react";
import Cookies from 'js-cookie'
import { Navigate, Outlet } from "react-router-dom";
import { PATH } from "./CustomRoutes";
import { COOKIE_AUTH } from "../constants/cookies";


export default function PrivateOutlet() {
  return Cookies.get(COOKIE_AUTH.TOKEN) != null ? <Outlet /> : <Navigate to={PATH.LOGIN} />;
}